module.exports = __webpack_public_path__ + "media/images/buriel-6-2457aae07214015c3ebf0610b3ea08bf.png";